<template>
  <div>
    <label>
      <input :checked="!anyRemaining" @change="checkAllTodos" type="checkbox"/> Check All
    </label>
  </div>
</template>

<script>
export default {
  name: "TodoCheckAll",
  computed: {
    anyRemaining() {
      return this.$store.getters.anyRemaining
    }
  },
  methods:{
      checkAllTodos() {
      this.$store.dispatch('checkAll', event.target.checked)
    },
  }
};
</script>